/**
 * Admin Dashboard Stats RPC definitions
 *
 * Admin endpoint for dashboard overview statistics - requires admin role.
 *
 * @since 1.0.0
 */
import { Rpc, RpcGroup } from "@effect/rpc";
import { Schema } from "effect";
import { AdminMiddleware } from "../admin.tags.ts";
import { DatabaseError, Forbidden, Unauthorized } from "../errors.ts";

// ============================================================================
// Response Schemas
// ============================================================================

/**
 * Dashboard stats response with counts for each card
 *
 * Fields with `NullOr` are placeholders for systems not yet built.
 *
 * @since 1.0.0
 */
export const DashboardStatsResponse = Schema.Struct({
  activeNodes: Schema.NullOr(Schema.Number),
  onboardingsInProgress: Schema.Number,
  openIncidents: Schema.NullOr(Schema.Number),
});

export type DashboardStatsResponse = Schema.Schema.Type<typeof DashboardStatsResponse>;

// ============================================================================
// RPC Group
// ============================================================================

/**
 * Admin Stats RPC group
 *
 * Provides dashboard overview statistics.
 * All endpoints require admin role via AdminMiddleware.
 *
 * @since 1.0.0
 */
export class AdminStatsRpcs extends RpcGroup.make(
  Rpc.make("admin.stats.dashboard", {
    success: DashboardStatsResponse,
    error: Schema.Union(Unauthorized, Forbidden, DatabaseError),
  }).middleware(AdminMiddleware),
) {}
